import * as React from "react"
const DownloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#A1A1A1"
      d="M6.585 12.581a2 2 0 0 0 2.829.001l2.141-2.141a.667.667 0 0 0-.942-.941l-1.951 1.951.004-10.284a.667.667 0 0 0-1.333 0l-.006 10.272L5.387 9.5a.667.667 0 0 0-.942.943l2.14 2.138Z"
    />
    <path
      fill="#A1A1A1"
      d="M15.333 11.167a.667.667 0 0 0-.666.666V14.5a.667.667 0 0 1-.667.667H2a.667.667 0 0 1-.667-.667v-2.667a.667.667 0 1 0-1.333 0V14.5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2.667a.667.667 0 0 0-.667-.666Z"
    />
  </svg>
)
export default DownloadIcon
